import { AlertTriangle } from 'lucide-react';

export default function TestBanner() {
  const isTest = !window.location.hostname.includes('ccbrjm.com');
  if (!isTest) return null;

  return (
    <div className="bg-red-600 text-white text-center py-1.5 px-4 text-xs font-medium sticky top-0 z-[70] flex items-center justify-center gap-2" data-testid="test-environment-banner">
      <AlertTriangle className="w-3.5 h-3.5" />
      Ambiente de teste
    </div>
  );
}
